import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const getPlannerMaterialDropdownData = createApi(`LTPlannerMaterialDropdownDataSlice`,"GET");

const LTPlannerMaterialDropdownDataSlice = createSlice({
  name: 'LTPlannerMaterialDropdownDataSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPlannerMaterialDropdownData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPlannerMaterialDropdownData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getPlannerMaterialDropdownData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default LTPlannerMaterialDropdownDataSlice.reducer;